import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modul/user'
import map from './modul/map'
import scenario from './modul/scenario'
import thematic from './modul/thematic'
// store
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        user,
        map,
        scenario,
        thematic
    }
})
